export default "__VITE_ASSET__c5e105c9__"